<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('account.child.title') }}</h3>
        </div>

        <div>
            <div class="mt-4">
                <div class="form-group">
                    <label>{{ $t('account.userId') }}</label>
                    <div>
                        <p class="pl-3">{{ external_user_id ? external_user_id : '-' }}</p>
                    </div>
                </div>
                <div class="form-group">
                    <label>{{ $t('account.edit.password') }}</label>
                    <div>
                        <p class="pl-3">{{ password ? password : '-' }}</p>
                    </div>
                </div>
            </div>

            <div class="text-center pt-3">
                <button type="button" id="regenerate" class="btn btn-outline-secondary" @click="handleOnClickRegenerateChild">
                    {{ $t('account.child.regenerate') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from '../../services/UserService';

    export default {
        name: 'UserChildAccount',

        components: {

        },

        data() {
            return {
                external_user_id: '',
                password: '',
            }
        },

        created() {
            this.fetchUserAccesses();
        },

        methods: {
            async fetchUserAccesses() {
                const result = await UserService.getChildAccesses();
                this.external_user_id = result.data.external_user_id;
                this.password = result.data.password;
            },

            async handleOnClickRegenerateChild() {
                try {
                   const result = await UserService.regenerateChildAccesses();
                   this.external_user_id = result.data.external_user_id;
                   this.password = result.data.password;
                } catch (err) {
                }
                document.getElementById('regenerate').blur();
            }
        }
    }
</script>

<style scoped>
    #regenerate {
        width: 194px;
    }
</style>